import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import {
  setFolders,
  setFoldersForDecisions,
} from '../../../../../../../folders/state/actions';
import { StateType } from '../../../../../../../state/reducers';

const mapState = ({ queryParams }: StateType) => ({
  query: queryParams.userQuery,
});

const mapDispatch = (dispatch: Dispatch) => ({
  updateDecisionsFolders(decisionsFolders: {
    [string: string]: Array<string>;
  }) {
    dispatch(setFoldersForDecisions(decisionsFolders));
  },
  updateFolders(
    folders: {
      folderKey: string;
      title: string;
    }[],
  ) {
    dispatch(setFolders(folders));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
